export default __webpack_public_path__ + "static/media/Share.0fab3cd7.svg";